export const BRAND_NAME = 'stayforlong'
export const BRAND_NAME_TITLE = 'Stayforlong'

export const PROPERTIES_PER_PAGE = 18
export const PROPERTIES_FOUND_THRESHOLD_BOOST_SUGGESTED = 6
export const DEFAULT_SUGGESTED_SEARCH_DISTANCE = 100
export const BOOSTED_SUGGESTED_SEARCH_DISTANCE = 300

export const DAYS_TO_START = 4
export const DAYS_OF_BOOKING = 3
